module.exports = __webpack_public_path__ + "static/media/bia-logo.d8977f71.png";